export default "__VITE_ASSET__BJ52pNva__"